module.exports = __webpack_public_path__ + "images/emoji/angry.dfb9955d038286df1b0e.png";